const ptAlphabetoValidation = /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/;

export /**
 * Valid if the value only contains letters
 *
 * @param {(string | undefined)} value
 * @return {*} 
 */
const portugueseAlphabeto = (value: string | undefined) => {
  if (value?.match(ptAlphabetoValidation)) {
    return true;
  }
  return false;
};

